/* jshint ignore:start */
// import external dependencies
import "jquery";

// Import everything from autoload
import "./autoload/_bootstrap.js";

// Import Vue views
import "./vue";

import noUiSlider from "nouislider";
import "slick-slider/slick/slick.min";
import tippy from "tippy.js";
import StarRating from "star-rating.js/src/star-rating.js";
import axios from "axios";
import { tafelgastenSliders } from "./modules/sliders";
import { loadArchive } from "./modules/archive";

function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

function setStyleRootVariables() {
  // Set navbar height px
  const adminbar = document.getElementById("wpadminbar");
  const navbar = document.querySelector(".wrapper-navbar");
  const searchbar = document.querySelector(
    ".wrapper-archive-sidebar-block-search"
  );

  document.documentElement.style.setProperty(
    "--admin-bar-height",
    (adminbar ? adminbar.offsetHeight : 0) + "px"
  );
  document.documentElement.style.setProperty(
    "--navbar-height",
    (navbar && getComputedStyle(navbar).position === "fixed"
      ? navbar.offsetHeight
      : 0) + "px"
  );
  document.documentElement.style.setProperty(
    "--searchbar-height",
    (searchbar && getComputedStyle(searchbar).position === "fixed"
      ? navbar.offsetHeight
      : 0) + "px"
  );
}

function archiveFunctions() {
  $("body").on(
    "keydown",
    "form#archive-sidebar input, form#archive-sort input",
    (event) => {
      if (event) {
        console.log(event);
        console.log(event.key);
        if (event.key === "Enter") {
          event.stopPropagation();
          event.preventDefault();
        }
      }
    }
  );

  $("body").on(
    "keydown",
    "form#archive-sidebar input, form#archive-sort input",
    debounce(
      () =>
        loadArchive(
          $("form#archive-sidebar, form#archive-sort, form#archive-time"),
          $("#archive-content")
        ),
      500
    )
  );

  $("body").on(
    "#archive-sidebar, #archive-sort, #archive-time",
    "change",
    function () {
      debounce(
        () =>
          loadArchive(
            $("form#archive-sidebar, form#archive-sort, form#archive-time"),
            $("#archive-content")
          ),
        1000
      );
      // loadArchive($('form#archive-sidebar, form#archive-sort, form#archive-time'), $('#archive-content'));
    }
  );

  window.archive_sidebar = () => {
    loadArchive(
      $("form#archive-sidebar, form#archive-sort, form#archive-time"),
      $("#archive-content")
    );
  };
}

// Tooltip fix for ajax

function onResize() {
  setStyleRootVariables();
}

function onReady($) {
  // Make preload dissapear
  $(".preloader").fadeOut("slow");

  // Show me more button
  let showMeMoreEl = $(".show-me-more");
  if (showMeMoreEl.length > 0) {
    showMeMoreEl.each(function () {
      const target = document.querySelectorAll($(this).data("target"));
      const isTextClamped = (elm) => elm.scrollHeight > elm.clientHeight;
      console.log(target[0].scrollHeight);
      console.log(target[0].clientHeight);
      console.log(isTextClamped(target[0]));
      if (target.length > 0 && !isTextClamped(target[0])) {
        $(this).remove();
      }
    });

    showMeMoreEl.on("click", function () {
      const lessLabel = $(this).data("less-label");
      const moreLabel = $(this).data("more-label");
      const target = $($(this).data("target"));

      $(this).toggleClass("active");
      target.toggleClass("more");

      if ($(this).hasClass("active")) {
        $(this).text(lessLabel);
      } else {
        $(this).text(moreLabel);
      }
    });
  }

  let switch_block = $("[name=switch_block]");
  if (switch_block.length > 0) {
    change_switch_block(switch_block);
    switch_block.change(function () {
      change_switch_block($(this));
    });
  }

  let rangeslider = $("#rangeSlider");
  if (rangeslider.length > 0) {
    let min = rangeslider.data("min");
    let max = rangeslider.data("max");
    noUiSlider.create(rangeslider[0], {
      start: [rangeslider.data("start"), rangeslider.data("end")],
      connect: true,
      step: rangeslider.data("step"),
      format: {
        to: function (value) {
          return "€ " + Math.round(value);
        },
        from: function (value) {
          return Number(value.replace("€", ""));
        },
      },
      tooltips: true,
      range: {
        min: Math.round(min),
        max: Math.round(max),
      },
    });

    rangeslider[0].noUiSlider.on("set", function (values, handle) {
      if (handle) {
        $("[name=price_max]").val(
          Math.round(Number(values[handle].replace("€", "")))
        );
      } else {
        $("[name=price_min]").val(
          Math.round(Number(values[handle].replace("€", "")))
        );
      }

      console.log("archive sidebar");

      window.archive_sidebar();
    });
  }

  let faq_item = $(".wrapper-faq-block-item");
  if (faq_item.length > 0) {
    faq_item.on("click", function () {
      $(this).toggleClass("active");
    });
    faq_item.first().addClass("active");
  }

  let mobile_filter_label = $(".wrapper-archive-sidebar-block-inputs");
  mobile_filter_label.on("click", function (e) {
    if (
      $(e.target).is("select") ||
      $(e.target).is("input") ||
      $(e.target).is("label")
    ) {
      return;
    }
    $(this).toggleClass("active");
  });

  let dropdown_menu_item = $(".dropdown");
  dropdown_menu_item.on("click", function () {
    $(this).find(".dropdown-menu").toggleClass("show");
  });

  if ($(".star-rating").length > 0) {
    new StarRating(".star-rating", {
      theme: "center-align",
      maxStars: 10,
      showText: false,
    });
  }

  let popper_els = $("[data-popper]");
  if (popper_els.length > 0) {
    popper_els.each(function () {
      let tooltip = $("#" + $(this).data("popper"));
      console.log("Pop!");
      tippy($(this)[0], {
        content: tooltip.html(),
        allowHTML: true,
        maxWidth: 400,
        interactive: true,
        delay: [0, 55100],
        placement: "top",
      });
    });
  }

  let register_form = $(".woocommerce-form-register");

  register_form.on("submit", function () {
    $(this).find("button").prop("disabled", true);
    // this.disabled = true;
  });
}

//Mobile  search filter aligned to top - navbar height
jQuery(() => {
  onResize(jQuery);
  onReady(jQuery);
  convertImages("img");
  tafelgastenSliders();
  archiveFunctions();
});

jQuery(window).on("resize", onResize);

$("body").tooltip({ selector: '[data-toggle="tooltip"]' });

// Payment triggers
window.paymentChange = (val) => {
  $('input[name="payment_method"]').each((i, item) => {
    if ($(item).val() === val) {
      $(item).parent().css("border-color", "#ec0055");
    } else {
      $(item).parent().css("border-color", "#ebebeb");
    }
  });
};

// Changes images containing SVG to HTML
const convertImages = (query, callback) => {
  const images = Array.from(document.querySelectorAll(query));
  images
    .filter((img) => img.src && img.src.includes(".svg"))
    .forEach((image) => {
      fetch(image.src)
        .then((res) => res.text())
        .then((data) => {
          const parser = new DOMParser();
          const svg = parser
            .parseFromString(data, "image/svg+xml")
            .querySelector("svg");
          if (!svg) {
            return;
          }

          if (image.alt) {
            svg.alt = image.alt;
          }

          if (image.id) {
            svg.id = image.id;
          }
          if (image.className) {
            svg.classList = image.classList;
          }

          if (!image.parentNode) {
            return;
          }

          image.parentNode.replaceChild(svg, image);
        })
        .then(callback)
        .catch((error) => console.error(error));
    });
};

// Function for Js switch
function change_switch_block(el) {
  let parent = el.parents(".step-switch-container");
  parent
    .find("[data-step]")
    .removeClass("active")
    .removeClass("items-container-item-last");
  if (el.is(":checked")) {
    el.parent().addClass("step-switch-checked");
    parent.find("[data-step=first]").addClass("active");
  } else {
    el.parent().removeClass("step-switch-checked");
    parent.find("[data-step=second]").addClass("active");
  }
  parent.find("[data-step]:visible:last").addClass("items-container-item-last");
}



// WEBPACK FOOTER //
// ./scripts/main.js